import { colors } from '../tokens/colors';
import { grid } from '../tokens/grid';
import { opacity } from '../tokens/opacity';
import { radius } from '../tokens/radius';
import { shadows } from '../tokens/shadows';
import { spacing } from '../tokens/spacing';
import { transitions } from '../tokens/transitions';
import { typography } from '../tokens/typography';
import { sharedCarouselTokens } from './shared-tokens';
export const empresaTheme = {
    'public-layout-background-color': colors.tertiary.product.green[500],
    'public-layout-opacity': opacity[0.2],
    'public-layout-separator-color': colors.neutral[0],
    'public-layout-text-color': colors.neutral[0],
    'sidebar-background': '#123015',
    'sidebar-border': '#123015',
    'sidebar-title-color': '#F2F2F2',
    'sidebar-item-border-radius': '4px',
    'sidebar-item-selected-bg': '#596E63',
    'sidebar-item-selected-text': '#FFFFFF',
    'sidebar-item-selected-icon-color': '#FFFFFF',
    'sidebar-item-text': '#FFFFFF',
    'sidebar-item-icon-color': '#FFFFFF',
    'sidebar-item-icon-bg': '#596E63',
    'sidebar-width-expanded': '206px',
    'sidebar-width-collapsed': '72px',
    'sidebar-padding': '12px',
    'sidebar-item-padding': '16px',
    'sidebar-gap': '4px',
    'sidebar-item-hover-bg': 'rgba(255, 255, 255, 0.1)',
    'sidebar-item-icon-gap': '12px',
    'sidebar-top-border-color': '#123015',
    'sidebar-collapse-icon-color': '#FFFFFF',
    'header-height': '64px',
    'header-padding': '0 24px',
    'header-gap': '16px',
    'header-title-weight': '600',
    'header-title-size': '18px',
    'link-default-font-size': '12px',
    'link-footer-font-size': '14px',
    'card-border-radius': '8px',
    'card-box-shadow': '0 2px 4px 0 rgba(0,0,0,0.12)',
    'card-padding': '36px',
    'welcome-onboarding-secondary-width': '100px',
    'shadow-xs': shadows.xs,
    'shadow-sm': shadows.sm,
    'shadow-md': shadows.md,
    'shadow-lg': shadows.lg,
    'shadow-xl': shadows.xl,
    'shadow-card': shadows.card,
    'shadow-card-hover': shadows.cardHover,
    'shadow-button': shadows.button,
    'transition-fast': transitions.fast,
    'transition-normal': transitions.normal,
    'transition-slow': transitions.slow,
    'transition-bounce': transitions.bounce,
    'transition-color': transitions.color,
    'transition-transform': transitions.transform,
    'transition-opacity': transitions.opacity,
    'transition-all': transitions.all,
    'progress-item-background': colors.neutral[500],
    'progress-item-indicator': colors.primary.orange[500],
    'progress-item-border-width': '2px',
    'progress-item-animation-duration': '1s',
    'success-green-light': colors.secondary.green[200],
    'success-green-dark': colors.secondary.green[500],
    'button-border-radius': '4px',
    'button-box-shadow': '0 2px 4px 0 rgba(0,0,0,0.12)',
    'button-padding-md': '8px 0',
    'button-padding-lg': '12px 0',
    'button-primary-text': colors.primary.orange[500],
    'background-alt': colors.secondary.blue[100],
    'background-white': colors.neutral[0],
    'brand-tr-orange': colors.primary.orange[500],
    'brand-tr-green': colors.tertiary.product.green[500],
    'info-card-background': colors.secondary.blue[100],
    'data-series-01': colors.secondary.green[500],
    'data-series-02': colors.secondary.blue[500],
    'data-series-03': colors.secondary.yellow[500],
    'data-series-04': colors.secondary.red[500],
    'data-series-05': colors.primary.orange[400],
    'data-series-06': colors.secondary.purple[500],
    'focus-default': colors.secondary.blue[500],
    'stepper-card-header-border': colors.neutral[300],
    'icon-action-medium-action': colors.primary.orange[500],
    'icon-neutral-dark': colors.neutral[800],
    'icon-neutral-stronger': colors.neutral[700],
    'icon-neutral-strong': colors.neutral[600],
    'icon-neutral-silver': colors.neutral[500],
    'icon-neutral-medium': colors.neutral[400],
    'icon-neutral-white': colors.neutral[0],
    'icon-primary-strong': colors.primary.orange[600],
    'icon-primary-medium': colors.primary.orange[500],
    'icon-primary-bright': colors.primary.orange[400],
    'link-default': colors.secondary.blue[500],
    'link-hover': colors.secondary.blue[600],
    'link-visited': colors.secondary.purple[500],
    'on-surface-neutral-stronger': colors.neutral[700],
    'on-surface-neutral-silver': colors.neutral[500],
    'on-surface-neutral-white': colors.neutral[0],
    'on-surface-primary-medium': colors.primary.orange[500],
    'status-muted': colors.neutral[700],
    'status-success': colors.secondary.green[500],
    'status-error': colors.secondary.red[500],
    'status-info': colors.secondary.blue[500],
    'status-warning': colors.secondary.yellow[500],
    'status-alert': colors.secondary.red[500],
    'stroke-neutral-dark': colors.neutral[800],
    'stroke-neutral-stronger': colors.neutral[700],
    'stroke-neutral-silver': colors.neutral[500],
    'stroke-neutral-subtle': colors.neutral[200],
    'stroke-primary-strong': colors.primary.orange[600],
    'stroke-primary-medium': colors.primary.orange[500],
    'stroke-primary-bright': colors.primary.orange[400],
    'stroke-primary-soft': colors.primary.orange[300],
    'surface-neutral-dark': colors.neutral[800],
    'surface-neutral-silver': colors.neutral[500],
    'surface-neutral-soft': colors.neutral[300],
    'surface-neutral-subtle': colors.neutral[200],
    'surface-neutral-pale': colors.neutral[100],
    'surface-neutral-white': colors.neutral[0],
    'surface-primary-strong': colors.primary.orange[600],
    'surface-primary-medium': colors.primary.orange[500],
    'surface-primary-bright': colors.primary.orange[400],
    'surface-primary-subtle': colors.primary.orange[200],
    'surface-tertiary-strong': colors.tertiary.product.green[500],
    'surface-tertiary-medium': colors.tertiary.product.green[400],
    'surface-tertiary-soft': colors.tertiary.product.green[300],
    'text-neutral-dark': colors.neutral[800],
    'text-neutral-stronger': colors.neutral[700],
    'text-neutral-strong': colors.neutral[600],
    'text-neutral-silver': colors.neutral[500],
    'text-neutral-medium': colors.neutral[400],
    'text-neutral-soft': colors.neutral[300],
    'text-neutral-subtle': colors.neutral[200],
    'text-neutral-pale': colors.neutral[100],
    'text-neutral-white': colors.neutral[0],
    'text-primary-strong': colors.primary.orange[600],
    'text-primary-medium': colors.primary.orange[500],
    'text-primary-bright': colors.primary.orange[400],
    'disabled-subtle-text': colors.neutral[600],
    'disabled-subtle-surface': colors.neutral[300],
    'inline-error-background': colors.secondary.red[200],
    'font-family-base': typography.fontFamilyBase,
    'font-family-clario': typography.fontFamilyClario,
    'font-weight-regular': typography.fontWeightRegular,
    'font-weight-medium': typography.fontWeightMedium,
    'font-weight-semibold': typography.fontWeightSemiBold,
    'font-weight-bold': typography.fontWeightBold,
    'type-display-font-size': typography.typeDisplayFontSize,
    'type-display-font-weight': typography.typeDisplayFontWeight,
    'type-display-line-height': typography.typeDisplayLineHeight,
    'type-heading-lg-font-size': typography.typeHeadingLgFontSize,
    'type-heading-lg-font-weight': typography.typeHeadingLgFontWeight,
    'type-heading-lg-line-height': typography.typeHeadingLgLineHeight,
    'type-heading-md-font-size': typography.typeHeadingMdFontSize,
    'type-heading-md-font-weight': typography.typeHeadingMdFontWeight,
    'type-heading-md-line-height': typography.typeHeadingMdLineHeight,
    'type-title-lg-font-size': typography.typeTitleLgFontSize,
    'type-title-lg-font-weight': typography.typeTitleLgFontWeight,
    'type-title-lg-line-height': typography.typeTitleLgLineHeight,
    'type-title-md-font-size': typography.typeTitleMdFontSize,
    'type-title-md-font-weight': typography.typeTitleMdFontWeight,
    'type-title-md-line-height': typography.typeTitleMdLineHeight,
    'title-global-margin-bottom': '20px',
    'type-subtitle-md-font-size': typography.typeSubtitleMdFontSize,
    'type-subtitle-md-font-weight': typography.typeSubtitleMdFontWeight,
    'type-subtitle-md-line-height': typography.typeSubtitleMdLineHeight,
    'type-paragraph-lg-font-size': typography.typeParagraphLgFontSize,
    'type-paragraph-lg-font-weight': typography.typeParagraphLgFontWeight,
    'type-paragraph-lg-line-height': typography.typeParagraphLgLineHeight,
    'type-paragraph-lg-regular-font-weight': typography.typeParagraphLgRegularFontWeight,
    'type-paragraph-lg-regular-line-height': typography.typeParagraphLgRegularLineHeight,
    'type-paragraph-md-font-size': typography.typeParagraphMdFontSize,
    'type-paragraph-md-font-weight': typography.typeParagraphMdFontWeight,
    'type-paragraph-md-line-height': typography.typeParagraphMdLineHeight,
    'type-paragraph-md-regular-font-weight': typography.typeParagraphMdRegularFontWeight,
    'type-paragraph-md-regular-line-height': typography.typeParagraphMdRegularLineHeight,
    'type-paragraph-sm-font-size': typography.typeParagraphSmFontSize,
    'type-paragraph-sm-regular-font-weight': typography.typeParagraphSmRegularFontWeight,
    'type-paragraph-sm-regular-line-height': typography.typeParagraphSmRegularLineHeight,
    'type-label-lg-font-size': typography.typeLabelLgFontSize,
    'type-label-lg-font-weight': typography.typeLabelLgFontWeight,
    'type-label-lg-line-height': typography.typeLabelLgLineHeight,
    'type-label-lg-regular-font-weight': typography.typeLabelLgRegularFontWeight,
    'type-label-lg-regular-line-height': typography.typeLabelLgRegularLineHeight,
    'type-label-md-font-size': typography.typeLabelMdFontSize,
    'type-label-md-font-weight': typography.typeLabelMdFontWeight,
    'type-label-md-line-height': typography.typeLabelMdLineHeight,
    'type-label-md-regular-font-weight': typography.typeLabelMdRegularFontWeight,
    'type-label-md-regular-line-height': typography.typeLabelMdRegularLineHeight,
    'type-label-sm-font-size': typography.typeLabelSmFontSize,
    'type-label-sm-font-weight': typography.typeLabelSmFontWeight,
    'type-label-sm-line-height': typography.typeLabelSmLineHeight,
    'type-label-sm-regular-font-weight': typography.typeLabelSmRegularFontWeight,
    'type-label-sm-regular-line-height': typography.typeLabelSmRegularLineHeight,
    'type-label-xs-font-size': typography.typeLabelXsFontSize,
    'type-label-xs-font-weight': typography.typeLabelXsFontWeight,
    'type-label-xs-line-height': typography.typeLabelXsLineHeight,
    'type-label-xs-regular-font-weight': typography.typeLabelXsRegularFontWeight,
    'type-label-xs-regular-line-height': typography.typeLabelXsRegularLineHeight,
    'type-caption-sm-font-size': typography.typeCaptionSmFontSize,
    'type-caption-sm-regular-font-weight': typography.typeCaptionSmRegularFontWeight,
    'type-caption-sm-regular-line-height': typography.typeCaptionSmRegularLineHeight,
    'line-height-auto': typography.lineHeightAuto,
    'line-height-100': typography.lineHeight100,
    'line-height-160': typography.lineHeight160,
    'line-height-180': typography.lineHeight180,
    'line-height-200': typography.lineHeight200,
    'line-height-body-sm': typography.lineHeightBodySm,
    'input-height': '48px',
    'submit-height': '48px',
    'font-size-xs': typography.fontSizeXs,
    'font-size-sm': typography.fontSizeSm,
    'font-size-md': typography.fontSizeMd,
    'font-size-lg': typography.fontSizeLg,
    'font-size-xl': typography.fontSizeXl,
    'font-size-2xl': typography.fontSize2xl,
    'font-size-3xl': typography.fontSize3xl,
    'font-size-4xl': typography.fontSize4xl,
    'spacing-0': spacing[0],
    'spacing-0-5': spacing[0.5],
    'spacing-1': spacing[1],
    'spacing-1-5': spacing[1.5],
    'spacing-2': spacing[2],
    'spacing-2-5': spacing[2.5],
    'spacing-3': spacing[3],
    'spacing-4': spacing[4],
    'spacing-4-5': spacing[4.5],
    'spacing-5': spacing[5],
    'spacing-6': spacing[6],
    'spacing-7': spacing[7],
    'spacing-8': spacing[8],
    'spacing-9': spacing[9],
    'spacing-10': spacing[10],
    'spacing-11': spacing[11],
    'spacing-12': spacing[12],
    'spacing-13': spacing[13],
    'spacing-14': spacing[14],
    'spacing-15': spacing[15],
    'radius-pill': radius.pill,
    'radius-xs': radius.xs,
    'radius-s': radius.s,
    'radius-m': radius.m,
    'grid-breakpoint-xxs': grid.breakpoints.xxs + 'px',
    'grid-breakpoint-xs': grid.breakpoints.xs + 'px',
    'grid-breakpoint-s': grid.breakpoints.s + 'px',
    'grid-breakpoint-m': grid.breakpoints.m + 'px',
    'grid-breakpoint-l': grid.breakpoints.l + 'px',
    'grid-gutter-xxs': grid.gutters.xxs,
    'grid-gutter-xs': grid.gutters.xs,
    'grid-gutter-s': grid.gutters.s,
    'grid-gutter-m': grid.gutters.m,
    'grid-gutter-l': grid.gutters.l,
    'grid-margin-xxs': grid.margins.xxs,
    'grid-margin-xs': grid.margins.xs,
    'grid-margin-s': grid.margins.s,
    'grid-margin-m': grid.margins.m,
    'grid-margin-l': grid.margins.l,
    'grid-columns-xxs': grid.columns.xxs,
    'grid-columns-xs': grid.columns.xs,
    'grid-columns-s': grid.columns.s,
    'grid-columns-m': grid.columns.m,
    'grid-columns-l': grid.columns.l,
    'grid-tokens-mobile': grid.tokens.mobile,
    'grid-tokens-tablet': grid.tokens.tablet,
    'grid-tokens-desktop': grid.tokens.desktop,
    'company-selection-bg': colors.tertiary.product.green[500],
    'company-selection-card-bg': colors.neutral[0],
    'company-selection-item-bg': colors.secondary.blue[100],
    'company-selection-item-selected-bg': colors.primary.orange[200],
    'company-selection-item-hover-bg': colors.neutral[200],
    'company-selection-radio-border': colors.neutral[700],
    'company-selection-radio-selected': colors.primary.orange[500],
    'company-selection-button-primary': colors.primary.orange[500],
    'company-selection-button-primary-hover': colors.primary.orange[600],
    'company-selection-button-secondary': 'transparent',
    'company-selection-button-secondary-text': colors.primary.orange[500],
    'company-selection-footer-link': colors.neutral[0],
    'company-selection-footer-separator': colors.neutral[0],
    'text-helper': colors.secondary.gray[400],
    'avatar-bg': colors.primary.orange[600],
    'avatar-text-color': colors.neutral[300],
    'avatar-border-color': colors.neutral[200],
    'avatar-focus-color': colors.primary.orange[500],
    'header-balance-text-color': colors.neutral[800],
    'header-balance-dot-color': colors.neutral[800],
    'header-company-selector-text-color': colors.neutral[800],
    'header-company-selector-focus-bg': colors.neutral[100],
    'header-company-selector-focus-border': colors.primary.orange[500],
    'header-divider-color': colors.neutral[400],
    'balance-text-color': colors.neutral[800],
    'profile-menu-background': colors.neutral[0],
    'profile-menu-border': colors.neutral[200],
    'profile-menu-user-name-color': colors.neutral[800],
    'profile-menu-user-cpf-color': colors.neutral[700],
    'profile-menu-close-icon-color': colors.neutral[800],
    'profile-menu-sign-out-color': colors.primary.orange[500],
    'product-card-background': colors.neutral[0],
    'product-card-icon-container-bg': colors.neutral[200],
    'product-card-icon-color': colors.primary.orange[500],
    'product-card-title-color': colors.neutral[800],
    'product-card-status-color': colors.neutral[700],
    'product-card-chevron-color': colors.primary.orange[500],
    'product-card-min-height': '64px',
    'product-card-icon-filter': 'brightness(0) saturate(100%) invert(30%) sepia(96%) saturate(1823%) hue-rotate(352deg) brightness(101%) contrast(98%)',
    'product-card-background-contracted': colors.primary.orange[500],
    'product-card-icon-filter-contracted': 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7495%) hue-rotate(270deg) brightness(100%) contrast(100%)',
    'opacity-0-2': opacity[0.2],
    'opacity-0-5': opacity[0.5],
    'opacity-0-8': opacity[0.8],
    'opacity-1': opacity[1],
    'neutral-dark-opacity-50': colors.neutral[80050],
    'product-card-icon-filter-contracted-empresa': 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(7495%) hue-rotate(270deg) brightness(100%) contrast(100%)',
    'primary-orange-filter': 'brightness(0) saturate(100%) invert(26%) sepia(95%) saturate(3332%) hue-rotate(16deg) brightness(96%) contrast(101%)',
    'status-info-filter': 'brightness(0) saturate(100%) invert(28%) sepia(98%) saturate(1409%) hue-rotate(194deg) brightness(98%) contrast(89%)',
    'breadcrumb-font-family': typography.fontFamilyBase,
    'breadcrumb-font-weight': typography.fontWeightSemiBold,
    'breadcrumb-font-size': '14px',
    'breadcrumb-line-height': '1.424',
    'breadcrumb-initial-color': colors.primary.orange[500],
    'breadcrumb-intermediate-color': colors.neutral[700],
    'breadcrumb-current-color': colors.neutral[800],
    'breadcrumb-initial-filter': 'brightness(0) saturate(100%) invert(30%) sepia(96%) saturate(1823%) hue-rotate(352deg) brightness(101%) contrast(98%)',
    'breadcrumb-intermediate-filter': 'invert(0) brightness(0.4)',
    ...sharedCarouselTokens,
    'image-text-color': colors.neutral[0],
    'image-heading-font-family': typography.fontFamilyClario,
    'separator-color': colors.neutral[400],
    'alert-info-background': '#EDF6FF',
    'alert-info-border': '#1573D3',
    'alert-info-text': colors.neutral[800],
    'alert-info-close-icon-color': colors.secondary.green[600],
    'checkbox-background': colors.secondary.blue[100],
    'checkbox-border': colors.neutral[700],
    'checkbox-border-radius': '2px',
    'checkbox-checked-background': colors.primary.orange[500],
    'checkbox-checked-border': colors.primary.orange[500],
    'checkbox-checked-icon-color': colors.secondary.blue[100],
    'checkbox-label-color': colors.neutral[800],
    'loading-background': colors.primary.orange[100],
};
